import React from 'react';
import './Car.css';

import { Button } from '../../components';
import { calculateAverageRating } from '../../utils';

import { FaStar, FaCar, FaGasPump, FaSuitcaseRolling, FaDollarSign } from 'react-icons/fa';
import { FaUserGroup } from "react-icons/fa6";

import { Link } from 'react-router-dom';



const Car = ({ car }) => {

  // Calculate the average rating of the car based on user reviews
  const averageRating = calculateAverageRating(car); 

  return ( 
    <div className="car-item">

      <div className='car-image'>
        <img src={car.image} alt={car.name} /> {/* Car Image */}
        <div className='price'><span>Per Day</span>{car.price}</div> {/* Car Price */}
      </div>

      <div className="content">

        {/* Car name with link to car details page */}
        <Link to={{
            pathname: '/Cars/' + car.name,
          }}
          state={car}>
          <h2>{car.name}</h2>
        </Link>

        {/* Car rating */}
        <div className='rating'>
          <div className='icon'>
            {/* Display star icons for rating */}
            <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
          </div>
          {/* Display average rating and number of comments */}
          {car.comments.length > 0 ? (
            <h5>{averageRating} ({car.comments.length})</h5>
          ) : (
            <h5>Not rated</h5>
          )}
        </div>

        {/* Car specifications */}
        <div className="details">
          <div className='detail-item'>
            <h3><FaCar className="icon" /><span>{car.details.type}</span></h3>
            <h3><FaUserGroup className="icon" /><span>{car.details.seats}</span></h3>
          </div>
          <div className='detail-item'>
            <h3><FaSuitcaseRolling className="icon" /><span>{car.details.suitcase}</span></h3>
            <h3><FaGasPump className="icon" /><span>{car.details.fuelType.join(', ')}</span></h3>
          </div>
          <div className='detail-item'>
            <h3><FaCar className="icon" /><span>{car.details.transmission.join(', ')}</span></h3>
            <h3><FaDollarSign className="icon" /><span>{car.details.costPerMile}</span></h3>
          </div>
        </div>

        {/* Button Container */}
        <div className="btn-container">

          {/* Rent Car Button */}
          <Button link={'Car-Booking'} title={'Book Now'} />

          {/* Link to car details page */}
          <Link
            to={{ pathname: '/Cars/' + car.name }}
            state={car}
            className="btn"
          >Details
          </Link>

        </div>
      </div>
    </div>
  );
};

export default Car;